(() => {
  if (customElements.get('park-product-testimonials')) return;
  customElements.define('park-product-testimonials', class extends HTMLElement {
    connectedCallback() {
      if (this._initialized) { this.startAutoplay(); return; }
      this._initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
      this.buttons = Array.from(this.querySelectorAll('[data-review-select]'));
      this.rail = this.querySelector('.park-product-testimonials__slides');
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.show(index)));
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index);
        this.editorPaused = true;
        this.schedule();
      });
      this.rail?.addEventListener('scroll', () => {
        const left = this.rail.getBoundingClientRect().left;
        let nearest = 0;
        this.slides.forEach((slide, index) => {
          if (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[nearest].getBoundingClientRect().left - left)) nearest = index;
        });
        this.select(nearest);
      }, { passive: true });
      const navigation = this.querySelector('.park-product-testimonials__navigation');
      if (navigation) navigation.hidden = false;
      this.select(0);
      this.startAutoplay();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.autoplayEvents?.abort();
      this.observer?.disconnect();
    }
    startAutoplay() {
      if (this.dataset.autoplay !== 'true' || !this.rail) return;
      this.autoplayEvents?.abort();
      this.observer?.disconnect();
      this.autoplayEvents = new AbortController();
      const options = { signal: this.autoplayEvents.signal };
      this.desktop = matchMedia('(min-width: 761px)');
      this.hoverQuery = matchMedia('(hover: hover)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = this.matches(':hover');
      this.focused = !!this.querySelector(':focus-visible');
      this.inView = false;
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', event => { this.focused = event.target.matches(':focus-visible'); this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'); this.schedule(); }, options);
      this.rail.addEventListener('pointerdown', () => { this.touching = true; this.schedule(); }, options);
      const release = () => { this.touching = false; this.schedule(); };
      document.addEventListener('pointerup', release, options);
      document.addEventListener('pointercancel', release, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.desktop.addEventListener('change', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.rail.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.1 });
      this.observer.observe(this);
      this.schedule();
    }
    lastPosition() {
      if (!this.rail || this.slides.length < 2) return 0;
      const step = this.slides[1].getBoundingClientRect().left - this.slides[0].getBoundingClientRect().left;
      return step > 0 ? Math.min(this.slides.length - 1, Math.ceil((this.rail.scrollWidth - this.rail.clientWidth) / step - 0.01)) : 0;
    }
    schedule() {
      clearTimeout(this.timer);
      const enabled = this.dataset.autoplay === 'true' && !this.motion?.matches && this.lastPosition() > 0;
      if (!enabled || !this.isConnected || !this.inView || document.hidden || this.touching || (this.hovered && this.hoverQuery?.matches) || this.focused || this.editorPaused) return;
      const seconds = Math.max(3, Math.min(15, Number(this.dataset.interval) || 6));
      this.timer = setTimeout(() => {
        this.show(this.currentIndex >= this.lastPosition() ? 0 : this.currentIndex + 1);
        this.schedule();
      }, seconds * 1000);
    }
    select(index) {
      this.currentIndex = index;
      this.buttons.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
    }
    show(index) {
      if (!this.slides[index] || !this.rail) return;
      const offset = this.slides[index].getBoundingClientRect().left - this.rail.getBoundingClientRect().left;
      this.rail.scrollBy({ left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.select(index);
    }
  });
})();
